import { BROWSER_TILE_KEYS } from "../../src/components/modules/Connect/BrowserWalletInfo/types"
import { HW_TILE_KEYS } from "../../src/components/modules/Connect/HumanWalletInfo/types"

export default {
  links: {
    goBack: "Go back",
    goBackToHome: "Go back to home",
  },
  humanWalletRegistration: {
    stepChip: "Step 1 of 2",
    title: "Create your account",
    description:
      "You only need a username. Then your device will ask for FaceID or fingerprint to create your passkey.",
    button: "Register",
    form: {
      username: {
        placeholder: "Username",
      },
      conditions: {
        label:
          "I confirm that I understand that Tutellus is not responsible for storing the private key of my wallet, and I am solely responsible for it.",
      },
      submit: {
        label: "Create my HumanWallet",
      },
    },
  },
  browserWalletConnect: {
    title: "Choose your wallet",
    description: "Your extension will open to approve the connection.",
  },
  tutellus: "Tutellus",
  connect: "Connect your wallet",
  connectTo: "Connect to {{projectToken}}",
  connectTutellus_intro:
    "Access Tutellus with HumanWallet: an easy-to-use wallet, perfect for mobile access and no gas fees.",
  account_HW: "First time here?",
  click_here: "Create your account in 1 minute",
  haveAccount: "Already have an account?",
  loginLink: "Log in",
  detected: "Detected",
  create_HW: "Create your user in 1 minute and operate easily in Web3 from anywhere.",
  or: "or",
  connect_conventional: "Browser wallet",
  connect_browser: "Conventional",
  connect_abstracted: "Continue with HumanWallet",
  connect_legal: "By connecting, you will need to sign a legal disclaimer before using the DEX.",
  connect_type: "What type of wallet do you want to connect with?",
  hero: {
    eyebrow: "Access",
    lead: "The crypto future",
    emphasis: "starts with you",
    description: "Connect to mint your POAPs and take your achievements to your wallet.",
    features: [
      "HumanWallet: sign in with your email, no seed phrase.",
      "Already have a wallet? MetaMask and compatible.",
      "Your POAPs live at your address, not in our database.",
    ],
  },
  card_sub: "One step and you're in. We never hold custody.",
  learn_browser: "What is a browser wallet?",
  learn_hw: "How does HumanWallet work?",
  dex_title: "Access the POAPs service",
  dex_description:
    "A POAP is a unique and non-transferable NFT that students of Tutellus receive after completing a training.",
  browser_wallet: {
    eyebrow: "Browser wallet",
    heading: {
      lead: "Your keys,",
      emphasis: "your control",
    },
    lead: "Connect MetaMask or any compatible extension. Tutellus never touches your keys: we'll only ask you for a signature.",
    tiles: {
      [BROWSER_TILE_KEYS.SelfCustody]: {
        name: "Self-custody",
        description: "Only you control your private keys.",
      },
      [BROWSER_TILE_KEYS.Versatility]: {
        name: "Versatility",
        description: "The same wallet for all of web3.",
      },
      [BROWSER_TILE_KEYS.Privacy]: {
        name: "Privacy",
        description: "Nothing is linked to your identity.",
      },
    },
    know: {
      title: "What you should know",
      items: [
        "There is no “forgot password”: if you lose your seed phrase, nobody can recover it for you.",
        "Always check that you are signing on the official Tutellus domain.",
      ],
    },
  },
  abstrated_wallet: {
    title: "HumanWallet",
    heading: {
      lead: "Sign in with your fingerprint,",
      emphasis: "no seed phrase",
    },
    lead: "The wallet built into Tutellus: a real address in your name, signed with your device's biometrics.",
    tiles: {
      [HW_TILE_KEYS.Biometry]: {
        name: "Biometrics",
        description: "Sign with FaceID or fingerprint. No passwords.",
      },
      [HW_TILE_KEYS.NoGas]: {
        name: "No gas",
        description: "Network fees are covered by Tutellus.",
      },
      [HW_TILE_KEYS.MultiDevice]: {
        name: "Multi-device",
        description: "The same account on any device.",
      },
      [HW_TILE_KEYS.NoInstall]: {
        name: "Nothing to install",
        description: "It lives inside the webapp itself.",
      },
    },
    know: {
      title: "What you should know",
      items: [
        "Your wallet is linked to your biometrics: you gain convenience, you give up some privacy.",
        "Your key is stored by your passkey provider (Apple, Google or another you choose).",
      ],
    },
  },
  noWallets: {
    chip: "No wallets detected",
    title: "We couldn't find any extension",
    description:
      "This browser has no wallets installed. You can install one, or sign in without an extension using HumanWallet.",
    cta: "Continue with HumanWallet",
    install: "Install MetaMask",
  },
  wrongChain: {
    chip: "Wrong network",
    title: "You're on another network",
    description: "Your wallet is connected to a network different from the Tutellus POAPs one. Switch it to continue.",
    cta: "Switch network",
  },
  learn_more: "Learn more",
  abstracted_wallet: "HumanWallet",
  switch_network: "Switch network",
  switch: "Switch",
  selectAccess: "Choose your access method",
  selectAccessText: "Select your browser wallet for greater control or HumanWallet for a fast and simple experience.",
  connect_intro: "You can use a conventional Wallet or HumanWallet, which simplifies access to operations.",
  connectWallet: "Connect with your Wallet",
  connectWalletText: "Use your browser wallet to securely access your dApps.",
  noConnectWallet: "No Wallets detected",
  noConnectWalletText:
    "It seems like there are no browser wallets available on your device. Please install a wallet extension like MetaMask or Brave Wallet to continue, or try accessing with HumanWallet",
  register_or_login: "Register now or log in with your user to access your Abstracted Wallet account.",
  login: "Login",
  loginText: "Access with your passkey and enjoy a secure and fast experience.",
  usernameWarning: "Enter at least three characters",
  register: "Register",
  registerText: "Create your account with HumanWallet. Choose a username and start using it without complications.",
  selectUserName: "Enter your username",
  userName: "Username",
  return_home: "Return to home",
  loading: "Loading...",
  languages: {
    en: "EN",
    es: "ES",
  },
  learn_more_private_keys: "Where are my keys stored?",
  passkeys_modal_title: "Passkeys",
  passkeys_seed_heading: "Where is the seed of my HumanWallet stored?",
  passkeys_seed_text:
    "HumanWallet integrates two cutting-edge standards (ERC7212 and ERC4337), the latter transforming wallets into 'smart accounts', which are smart contracts. This means your HumanWallet does not have a seed but a private key associated with the contract.",
  passkeys_key_heading: "Where is the private key associated with my HumanWallet stored?",
  passkeys_key_text:
    "Most users delegate the 'passkeys' service to Apple (iCloud Keychain) or Google (Password Manager), but you can also store them with another external provider.",
  passkeys_providers_heading: "What other providers exist to store private keys?",
  passkeys_providers_text: "There are many providers besides the two major ones (Apple and Google), such as:",
  passkeys_providers_bitwarden: "an open-source solution offering high security and flexibility.",
  passkeys_providers_protonpass:
    "an alternative focused on privacy and security, ideal for those seeking maximum data protection.",
  and: "and",
  disclaimer:
    "I confirm that I understand that Tutellus is not responsible for storing the private key of my wallet, and I am solely responsible for it.",
  back: "Back to home",
}
